import { Badge, BadgeProps } from '@fluentui/react-components';
import { WarningRegular } from '@fluentui/react-icons';

import { CRITICALITY, TCriticality } from '../../models';

const CRITICALITY_COLOR: Record<TCriticality, BadgeProps['color']> = {
  [CRITICALITY.LOW]: 'informative',
  [CRITICALITY.MEDIUM]: 'warning',
  [CRITICALITY.HIGH]: 'danger',
  [CRITICALITY.CRITICAL]: 'danger',
};

type TProps = {
  criticality?: TCriticality;
  size?: BadgeProps['size'];
};

export const CriticalityBadge = ({ criticality, size = 'medium' }: TProps) => {
  if (!criticality)
    return (
      <Badge appearance="outline" color="subtle" size={size}>
        Not set
      </Badge>
    );
  const showWarning = criticality === CRITICALITY.HIGH || criticality === CRITICALITY.CRITICAL;
  return (
    <Badge
      appearance="tint"
      color={CRITICALITY_COLOR[criticality]}
      size={size}
      icon={showWarning ? <WarningRegular /> : undefined}
    >
      {criticality}
    </Badge>
  );
};
